export class OrderFormValidationException extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'OrderFormValidationException'
  }
}
